// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.opYVRfNxUMJaa2nTozZY{padding:8px 24px 16px}.h6BTWcoW5c82prQTWhBn{margin-top:40px;margin-bottom:10px;display:inline-flex}.KkGMWeIJx08vdrtBFZUO{gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollbarView": `opYVRfNxUMJaa2nTozZY`,
	"title": `h6BTWcoW5c82prQTWhBn`,
	"images": `KkGMWeIJx08vdrtBFZUO`
};
export default ___CSS_LOADER_EXPORT___;
